export default __webpack_public_path__ + "static/media/Jest.1d567899.png";